class ShiftsListController {
    public currentPage: number;
    public itemsPerPage: number;

    constructor() {
        'ngInject';
    }

    public $onInit = () => {
        this.currentPage = 1;
        this.itemsPerPage = 12;
    }

    public $onChanges = () => {
    
    }
    
    parseDate(item) {
        var date = new Date(item.start);
        return date;
    }
}

export const shiftsListComponent = {
    bindings: {
        history: "<"
    },
    controller: ShiftsListController,
    template: require('./shifts.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/shifts/shifts.list.component.ts